import React, { useEffect, useState } from 'react';
import { ReactComponent as Underline } from '../../../assets/images/underline.svg';
import { ReactComponent as BurgerIcon } from '../../../assets/icons/burger-icon.svg';
import { apiService } from 'utils/api';
import { handleApiError } from 'utils/functions';

export type BrandApiResponse = {
  brand_id: string;
  brand_name: string;
  total_orders_today: string;
  logo: string;
};

const BrandCard = ({ data }: { data: BrandApiResponse }) => {
  return (
    <div className='bg-[#F7F7F7] rounded w-[361px] min-h-full flex flex-col'>
      <div className='flex justify-start grow min-h-full'>
        <div className='p-[20px]'>
          <div className='flex gap-4 '>
            <div className='max-w-[30px] h-[30px] mb-[12px]'>
              {data.logo ? <img src={data.logo} /> : null}
            </div>
            <div className='grow'>
              <p className='eucledian font-semibold mb-3 '>{data.brand_name}</p>
              <p className='text-[32px] leading-[130%] font-semibold'>{data.total_orders_today} </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const KitchenStatsPageThree = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<BrandApiResponse[]>([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await apiService.get<{ data: BrandApiResponse[] }>('kitchen/orders-per-brand', {
        baseUrl: process.env.REACT_APP_KITCHEN_API_URL
      });

      setData(res.data.data);
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();

    const interval = setInterval(() => {
      fetchData();
    }, 300000); // Refresh every 5 minutes

    return () => clearInterval(interval);
  }, []);

  const totalOrders = data.reduce((acc, brand) => acc + Number(brand.total_orders_today), 0);

  return (
    <div>
      <div className='intro flex flex-col'>
        <BurgerIcon />
        <p className='eucladian text-[60px] text-[#2E3031] font-semibold mt-[18px]'>
          {totalOrders} <span className='text-[#6F7376]'>meals preprared</span>
        </p>
        <Underline />
        <p className='inkfree text-[#5E6164] font-medium mt-[18px] mb-[40px] text-[16px]'>
          What this means for THE FC brands
        </p>
        {loading ? (
          '...'
        ) : (
          <div>
            <div className='grid grid-cols-3 gap-[32px]'>
              {data.map((item) => (
                <BrandCard key={item.brand_id} data={item} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default KitchenStatsPageThree;
